import React from "react";

import { Reorder, useDragControls } from "framer-motion";
import { Reorderable } from "types";

export const ReorderableListItem = ({
  listItem,
  children,
  onDragStart,
  onDragEnd,
}: {
  listItem: Reorderable;
  children: React.ReactNode;
  onDragStart: (listItem: Reorderable) => void;
  onDragEnd: () => void;
}) => {
  const dragControls = useDragControls();

  const startDrag = (e: React.PointerEvent) => {
    e.preventDefault();
    dragControls.start(e);
  };

  return (
    <Reorder.Item
      value={listItem}
      className="list-group-item d-flex align-items-start gap-2"
      dragControls={dragControls}
      dragListener={false}
      onDragStart={() => {
        onDragStart(listItem);
      }}
      onDragEnd={() => {
        onDragEnd();
      }}
    >
      <div className="flex-grow-1 min-w-0">{children}</div>
      <button
        type="button"
        className="btn btn-link text-secondary p-0 ms-auto flex-shrink-0"
        aria-label="Drag to reorder"
        onPointerDown={startDrag}
        style={{ touchAction: "none" }}
      >
        <i className="bi-grip-vertical" aria-hidden="true"></i>
      </button>
    </Reorder.Item>
  );
};
